import React from "react";
import { Box } from "@mui/material";

/**
 * A small key hint inside a button, e.g. "⌘ Enter" on "Complete Sale".
 * Drawn in the button's own text colour, so it suits any variant.
 */
export const KeyHint: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Box
        component="kbd"
        sx={{
            ml: 1,
            px: 0.75,
            borderRadius: 0.75,
            border: "1px solid currentColor",
            opacity: 0.75,
            fontFamily: "inherit",
            fontSize: "0.7rem",
            fontWeight: 600,
            lineHeight: 1.7,
            whiteSpace: "nowrap",
        }}
    >
        {children}
    </Box>
);
